export function prefixAssignmentTitle(title: string, prefix: string = 'Opdracht'): string {
    if (!title.startsWith(prefix)) {
        return `${prefix} ${title}`;
    }

    return title;
}
